import { DatePipe } from '@angular/common';

export class FomatDateClass {
  constructor() {}

  static fechaSinSeparacion(fecha: string) {
    return fecha.replace(/\-/g, '');
  }

  static fechaConSlash(fecha: string) {
    return fecha.replace(/\-/g, '/');
  }

  static getFormatDateDB(date: Date, prepareBD?: boolean): string {
    let day = date.getDate();
    let month = date.getMonth();
    let year = date.getFullYear();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    if (prepareBD) {
      return year + '-' + this._getMonthText(month) + '-' + this._to2digit(day) + ' ' + this._to2digit(hour) + ':' + this._to2digit(minute) + ":" + this._to2digit(second);
    } else {
      return this._to2digit(day) + '/' + this._getMonthText(month) + '/' + year;
    }
  }

  static getFormatDate(date: any, formater?: string): string {
    let formatFecha = '';
    try {
      if (date instanceof Date) {
        let dateFec: Date = new Date(date);
        if (formater == '') {
          formater = 'yyyy/MM/dd';
        }
        let day = dateFec.getDate();
        let month = dateFec.getMonth();
        let year = dateFec.getFullYear();
        let yeartwo = dateFec.getFullYear().toString().substring(2, 4);
        let hour = dateFec.getHours();
        let minute = dateFec.getMinutes();
        let second = dateFec.getSeconds();
        // "dd/MM/yyyy"
        // "dd-MM-yyyy"
        // "yyyy-MM-dd"
        // "yyyy/MM/dd"
        // "yyyy/MM/dd hh:mm:ss"
        formatFecha = formater
          .replace('yyyy', year.toString())
          .replace('yy', yeartwo)
          .replace('MM', this._getMonthText(month))
          .replace('dd', this._to2digit(day))
          .replace('hh', this._to2digit(hour))
          .replace('mm', this._to2digit(minute))
          .replace('ss', this._to2digit(second));
      } else {
        let delimitador = '';
        if (date.split('-').length == 3) {
          delimitador = '-';
        } else if (date.split('/').length == 3) {
          delimitador = '/';
        }
        if (delimitador !== '') {
          let day = parseInt(
            date.split(delimitador)[0].length == 2
              ? date.split(delimitador)[0]
              : date.split(delimitador)[2],
            10
          );
          let month = parseInt(date.split(delimitador)[1], 10) - 1;
          let year = parseInt(
            date.split(delimitador)[0].length == 4
              ? date.split(delimitador)[0]
              : date.split(delimitador)[2],
            10
          );
          formatFecha = formater
            .replace('yyyy', year.toString())
            .replace('MM', this._getMonthText(month))
            .replace('dd', this._to2digit(day));
        }
      }
    } catch (error) {
      console.error('error', error);
      formatFecha = '';
    }

    return formatFecha;
  }

  static _to2digit(n: number) {
    return ('00' + n).slice(-2);
  }

  static _getMonthText(month): string {
    let meses = [
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
    ];
    return meses[month];
  }
}
